import {Col, Form, FormGroup, Row, FormSelect} from "react-bootstrap";
import {PublicTransportImport} from "../../../../../types/LayerAdmin/PublicTransportImport";
import {PublicTransportImportType} from "../../../../../constant/PublicTransportImportType";
import {ErrorText} from "../../../../../@ui/ErrorText";

interface UsTransitMergeImportFieldsProps {
  values: any;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: any) => void;
  errors: any;
  touched: any;
  imports: PublicTransportImport[];
}

const UsTransitMergeImportFields = ({
                                     values,
                                     handleChange,
                                     handleBlur,
                                     errors,
                                     touched,
                                     imports,
                                   }: UsTransitMergeImportFieldsProps) => {
  return (
    <Row className="justify-content-center">
      <p className="text text-warning">To run the merger, a US Transit and Transitland must be completed. Then you will be able to
        select them from the dropdowns below.</p>
      <p className={"text text-info"}>Running this will only mark routes as deleted. It <i>can</i> be undone!<br />It will keep the route with the most trips from either import.</p>
      <Col className="col-md-10">
        <FormGroup className="w-100 mt-2">
          <Form.Label>US Transit Import ID: </Form.Label>
          <FormSelect
            name="usTransitImportId"
            value={values.usTransitImportId}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <option value="">Select US Transit Import...</option>
            {imports.filter(x => x.publicTransportImportType === PublicTransportImportType.UsTransit).map(x =>
              <option key={x.publicTransportImportId} value={x.publicTransportImportId}>
                {`ID: ${x.publicTransportImportId} (${x.importDate.toFormat("dd-MM-yyyy")})`}
              </option>)}
          </FormSelect>
          {errors.usTransitImportId && touched.usTransitImportId && (
            <ErrorText className="text-danger">
              {errors.usTransitImportId}
            </ErrorText>
          )}
        </FormGroup>

        <FormGroup className="w-100 mt-3">
          <Form.Label>Transitland Import ID: </Form.Label>
          <FormSelect
            name="transitLandImportId"
            value={values.transitLandImportId}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <option value="">Select Transitland Import...</option>
            {imports.filter(x => x.publicTransportImportType === PublicTransportImportType.TransitLand).map(x =>
              <option key={x.publicTransportImportId} value={x.publicTransportImportId}>
                {`ID: ${x.publicTransportImportId} (${x.importDate.toFormat("dd-MM-yyyy")})`}
              </option>)}
          </FormSelect>
          {errors.transitLandImportId && touched.transitLandImportId && (
            <ErrorText className="text-danger">
              {errors.transitLandImportId}
            </ErrorText>
          )}
        </FormGroup>
      </Col>
    </Row>
  );
};

export default UsTransitMergeImportFields;
